<div class="modal" tabindex="-1" role="dialog" id="appModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Please Confirm</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
                
            </div>
            <div class="modal-body">
                <p class="text-center font-weight-bold">{{confirmationQuestion}}</p>


                <p class="text-center font-weight-bold mt-1">{{confirmationDetails}}</p>
              
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="onNo()">{{'General.Cancel' | translate}}</button>

                <button type="button" class="btn btn-success" data-dismiss="modal" (click)="onYes()">{{'General.Yes' | translate}}</button>
            </div>
        </div>
    </div>
</div>